import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ConnectService {
  public userCountry = localStorage.getItem('countryVal');
  public isOpen = new BehaviorSubject<String>('en');
  public setIsUserSubscribedVal = new BehaviorSubject<Array<any>>([]);
  public selectedCountry = new BehaviorSubject<String>(this.userCountry);

  public toggle(lang): void {
    this.isOpen.next(lang);
  }

  public setIsUserSubscribed(val): void {
    this.setIsUserSubscribedVal.next(val)
  }
  
  public switchCountry(country): void {
    this.selectedCountry.next(country);
  }
}